<template>
    <div class="comments-section">
        <template v-if="!isLoadingComments">
            <template v-if="comments.length !== 0">
                <comment
                    v-for="comment in comments"
                    class="comments-section-comment"

                    :id="comment.id"
                    :content="comment.content"
                    :created="comment.created"
                    :created-by="comment.createdByName"
                    :is-editable="comment.isEditable"
                    :is-seen="comment.isSeen"
                    :sub-type="comment.subType"
                    :related-id="relatedId"

                    @editor-opened="onEditorOpened"
                />
            </template>
            <div v-else class="text-center">
                {{resource("JourneyBuilder_Comments_NoComments")}}
            </div>
        </template>
        <loader v-else class="loader" />
    </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import Comment from "./Comment";
import {getCurrentUser} from '@core/Util/current-user'
import {bootstrapDangerGrowl} from "@core/Util/growler";
import resourcesMixin from "@core/Util/Mixins/resources";
import Loader from "@modules/JourneyBuilder/Components/Elements/Loader";

const {mapState, mapGetters, mapActions} = createNamespacedHelpers('journeyBuilder/composer');

export default {
    name: "JourneyCommentsSection",
    components: {
        Loader,
        Comment
    },
    mixins: [resourcesMixin],
    async created() {
        this.currentUserId = getCurrentUser().Id;
        
        try {
            await this.loadJourneyComments({ relatedId: this.relatedId, type: this.type });
        } catch(e){
            bootstrapDangerGrowl(e);
        }
    },
    mounted() {
        //Scroll to last comment on open
        this.scrollToBottom();
    },
    methods: {
        ...mapActions(['loadJourneyComments']),
        isEditable(comment){
            //Comment is editable when: 
            // * It is made by the current user
            // * It is the latest comment made on the given journey component
            return comment.createdBy === this.currentUserId &&
                this.comments.indexOf(comment) === this.comments.length -1;
        },
        onEditorOpened(){
            //Our editor may be larger than our comment
            //scroll to the bottom to prevent potentially having save/cancel controls off-screen
            this.$nextTick(() => this.scrollToBottom());
        },
        scrollToBottom(){
            this.$el.scrollTo({
                top: this.$el.scrollHeight - this.$el.clientHeight
            });
        }
    },
    computed: {
        ...mapState(['journeyComments']),
        ...mapGetters({
            'storeHasUnseenComments': 'hasUnseenComments',
            'storeIsLoadingComments': 'isLoadingComments'
        }),
        /**
         * @return {JourneyComment[]}
         */
        comments(){
            return this.journeyComments[this.relatedId] || [];
        },
        hasUnseenComments(){
            return this.storeHasUnseenComments(this.relatedId);
        },
        isLoadingComments(){
            return this.storeIsLoadingComments(this.relatedId);
        }
    },
    data(){
        return {
            currentUserId: null
        };
    },
    props: {
        relatedId: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true,
            validator: value => value === 'Brick' || value === 'Connection'
        }
    }
}
</script>

<style scoped lang="scss">
    .comments-section {
        //Allow for loader to scale based on comment section size
        position: relative;
        
        //Take up a good amount of space to display our content
        min-width: 24rem;
        
        //By default: scale height with comment count
        min-height: 6rem;
        max-height: 18rem;
        overflow-y: auto;
        
        background-color: #EEEEEE;
        border-radius: 3px;
        
        .comments-section-comment {
            margin: 10px 15px;
        }
        
        .loader {
            position: absolute;
            height: 100%;
            width: 100%;
            top: 35%;
            text-align: left;
        }
    }
</style>